import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import './style/App.css'
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthProvider'
import App from './App';
import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
  broadcaster: "pusher",
  key: process.env.REACT_APP_WEBSOCKET_KEY,
  wsHost: process.env.REACT_APP_WEBSOCKET_WSHOST,
  enabledTransports: ["ws", "wss"],
  wsPort: 8443,
  wssPort: 8443,
  disableStats: false,
  forceTLS: true,
  encrypted: true,
});


ReactDOM.render(
  <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>  
        </AuthProvider>      
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
